import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './CardListItemGroup.module.css';
export type CardListItemGroupProps = ComponentProps<'div'> & {
  label: string;
};
export const CardListItemGroup: FunctionComponent<CardListItemGroupProps> = React.memo(props => {
  const $ = _c(12);
  let children;
  let label;
  let t0;
  let t1;
  if ($[0] !== props) {
    const {
      children: t2,
      label: t3,
      className,
      ...remainingProps
    } = prepareProps({
      props
    });
    children = t2;
    label = t3;
    t0 = remainingProps;
    t1 = classes(className, styles.group);
    $[0] = props;
    $[1] = children;
    $[2] = label;
    $[3] = t0;
    $[4] = t1;
  } else {
    children = $[1];
    label = $[2];
    t0 = $[3];
    t1 = $[4];
  }
  let t2;
  if ($[5] !== label) {
    t2 = label ? <div className={styles.label}>{label}</div> : undefined;
    $[5] = label;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== children || $[8] !== t0 || $[9] !== t1 || $[10] !== t2) {
    t3 = <div {...t0} className={t1}>{t2}{children}</div>;
    $[7] = children;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
});